<template>
  <nav class="grid-x logo-header">
    <div class="grid-x small-12 medium-4 middle-4 large-3 align-bottom align-center logotype">
      <a class="cell logo" href="/"><span>Workalicious</span>
        <svg class="logo-front on-light" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 368 123.8">
          <path
            d="M332.7,198.7c1.4-.9,3.1-1.8,5,1.1s-.8,7.3-3.1,9.1a3.8,3.8,0,0,1-5.5-.8c-.6-1.2-.6-3,.5-5.6A11,11,0,0,1,332.7,198.7Zm-39.9,14.2c-2.8,6.3,4.1,7.7,5.9,5.9s2.7-5.4,2.4-7.9-1.5-4.5-4.5-3.1S293.4,211.5,292.8,212.9Zm143.5,7c-2.8,0-8.7-.1-12.6.3s-4.4-.9-5.1-3.7c-1.6-7.5-10.9-7.7-11.8-7.7s-1.1-2.6.1-3.7,2.2-2.7,1.9-4.5c-.6-3.9-3.9-3.5-5.8-2.4a13.6,13.6,0,0,0-5.1,5.5,27.3,27.3,0,0,0-2.3,8.3c-.8,5.2-6.9,11.3-6.9,11.3-2.4,3.1-3.6,2-4.2.8s4-9.1,5-13.6c.6-2.9-1.7-4.2-3.9-3.5s-2.4,2.1-3,2.7-4,11-5.9,13.5-3.8,2.2-5.7,1.7,2.3-8.7,3.1-12.4-2.2-3.2-4.8-1.8-4.4,7.7-5.3,8.5a3.3,3.3,0,0,1-3.4.8,6.6,6.6,0,0,1-3.2-1.9c-1.6-4.2-4.7-9-9.2-7.6-2.1.4-3.3,4.3-7.6,7.5s-7,11.8-7.5,14.3-.6,5.2-4.4,6.1-3.6-2.2-3.6-2.2c-.6-2.7,3-10,4.1-12.3s3.4-4.8.2-6-4.7.5-5,1.4S316.9,236,313.7,239s-3.9,3.8-6.5,4.2c-8,2-6.2-5.6-5.3-9s3.5-2.6,4.6-2.3a5.6,5.6,0,0,0,6.3-1.7c2.2-2.9,2.7-6.7.5-9.2s-7.9.1-11.6,3.7-8.4,19-9.9,22-3.9,5.5-5,1.7,4.3-17.6,5.1-20.7c.4-1.4-1.9-4.4-4.9-.9s-5.9,14.7-7.6,18.1c-4.1,8.7-4.9,7.2-5.9,7.9s-3.8.5-3.6-2.2c.1-1.2,1.6-9.9,2.8-12.3a38.6,38.6,0,0,1,3.3-5.4c1.8-3,13.1-11.7,12.5-26.1a22.3,22.3,0,0,1,.6-4.6,11.2,11.2,0,0,0,.3-4.7c-.7-5.2-4.3-4-7,.4s-14.7,35-16.1,40-3,13-3.8,14.5l-1.4,3.1h0c-2.8,2.7-5.2,2-5.8.9s2.5-7.1,3.5-11.7c.7-2.9.9-6-1.6-6-.6.1-4.5.4-5.1,1s-2.1-.4-3.2-.4c-7.7,0-10.9,3.8-13.2,8.7-1.4,3.2-2.2,6.7-3.1,9.2s-1.1,3.5-1.4,4.4c-2.3,6.7-9.3,7.1-12.6,6.2-1.8-.5-3.3-2.8-3.1-4.2a21.5,21.5,0,0,0,9.1-2.4c5.1-2.7,6.4-6.4,5.5-9.5s-3.4-5.4-5.9-5.7-5.4.5-6.8.7a46.9,46.9,0,0,0,10.2-25.4c.4-4.4.7-7.1.3-9.3-1-5.2-4.5-3.7-6.9.8a160.7,160.7,0,0,0-8.5,20.9,142.7,142.7,0,0,0-4.7,18.4c-.2,1.2-.6,3.5-.8,4.9-3.1,15.8-7.7,17.9-8.7,18.3s-2.4-.3-2.9-1.7.7-4.9,2.3-8.8a22.6,22.6,0,0,1,2.9-5.4c.2-.3-.6-2.1-.9-2.3s-2.6-.6-4.8-1.9-1.6-2.6-1.4-4.5-5.3-5.3-6.2-2.8a105.2,105.2,0,0,1-4.1,9.9c-1.4,3.3-3,7.2-4.9,7.9-1.7-3.8-4.6-7.5-8.7-6.3-2,.5-3.2,4.4-7.6,7.6l-.2.2a7.3,7.3,0,0,1-4-.5q.8-3.1,1.5-6.6c.3-1.2.6-2.4.8-3.6.7-3.3.9-7.3,1.7-10.4a44.4,44.4,0,0,0,1.3-8.4c0-1.5,1.3-10.1,1-14s-1.3-7.6-2.6-9c-6.6-7-14.7,1.8-13.3,5.5a51.3,51.3,0,0,1,2.7,8.4c.4,1.8.8,3.7,1.1,5.6a67.8,67.8,0,0,1,.3,12.7,26.1,26.1,0,0,1-.4,3.1,29.1,29.1,0,0,1-.1,3,100.3,100.3,0,0,1-3.3,16l-.8,2.1c-.4,1.1-.7,2.4-1,3.4-1,3-2.1,5.7-3,7.8-4.9,11.6-9.2,9.9-11.4,5.9s-2.3-13.1-2.3-13.1a70.3,70.3,0,0,1,3.4-7.3,18,18,0,0,0,1.9-14.5c-.2-1.5-1.8-3.5-2.7-4.3s-3-.1-4.6.9c-6.8,4.1-4.3,17.2-3.5,22.6-1.4,4.8-10.9,23.5-14.7,27.4-1.3,1.3-4.2.8-4.4-3.8a53.9,53.9,0,0,1,.1-10.7c.4-4.4,4.3-29.1,10.7-51,1.1-3.7,2.8-8.7,2.8-10.9-.1-16.6-15.8-11.5-24.3-5.1s-16.1,17-18.9,27l-2.7,10.1a38.6,38.6,0,0,0-.2,17.5c2,8.7,9.8,3.3,10.9,2.2s9.6-9.9,10.3-13.1c.4-1.6-2-2-4-.9s-5.1.6-6,.7-1.9-2.2-2.6-5.5c0,0-.2-1.5-.3-2.4a2,2,0,0,1-.1-.7c-.8-5.3,1.7-11.2,3-14.5s4.8-11.1,13.8-13c11.9-2.3,7.5,13.4,6.3,19.4l-.6,2.8c-.6,2.7-1.5,5.7-2.4,9-1.7,6.9-5.7,20.7-7.1,27.3-1,4.7-2.6,12.1-3.1,16.3-.2,2,.1,3.4,0,5.9,0,.2.1,1.3.1,1.4a14.7,14.7,0,0,0,4.3,8.6,7.9,7.9,0,0,0,6.7,1.1c8.7-3.3,18.3-21.4,22.5-35,.2-.5.4-.4.4.1s.3,4.7,1,9.7a24.7,24.7,0,0,0,2.2,8.4c2.1,4.1,5.9,6.5,10.9,3.3a32.2,32.2,0,0,0,7.2-7.8,98.1,98.1,0,0,0,5.2-9.5,48.9,48.9,0,0,0,3-7.5h.6a6.1,6.1,0,0,0-.3,1.1,4.8,4.8,0,0,0-.3,1.8c-.3,3.2-.4,9.1,8.5,10.1s14.8-10.9,15.4-11.7l2-6.4a6.9,6.9,0,0,0,2.7-2.5c.9-1.3,1.3-2.6,2.4-4.5a44.1,44.1,0,0,0,2.5-5.2c1.5-4.1,3-1.5,4.6-1.4s-1.3,4.3-2.7,8.7a48.3,48.3,0,0,0-1.8,7.3c-.3,2.2-.6,4.9.4,6a5,5,0,0,0,4.1,1.6,8.6,8.6,0,0,0,4.9-2.3h0c.9-.6,3-4.2,4.5-3.3s1.7,1.7,4.4,1.7c.9.1,2-.7,3-1.7s.3-7.6.4-8.5.9-1.3,1.2-.6.3.8.4.9a11.3,11.3,0,0,0,4.8,5.7c3.4,1.6,8.6-.6,10.7-2.7s3.4-4.1,5.4-3.3,4.7,1.5,6.7.5,3.2-2.7,5.5-4.7l.6.2a8.4,8.4,0,0,0,4.6.7,16.7,16.7,0,0,0,3.2-1.1,7.7,7.7,0,0,0,1.6-.7c.9-.5,1.2-1.1,2.6-2.1s2.2-1.9,3.4-2.7l.5-.4a5.2,5.2,0,0,0,1.1.7c1.5,1,1.7,1.7,4.4,1.8s5.2-4.5,7.5-5.8,3.2-.5,5.6-.4,1.8-.2,4.4-.9,4,.3,4.9-.5,4.3-3.8,6.4-2.8a8.6,8.6,0,0,0,5,1c2.9,0,7.5-6.4,9.9-7.1a8,8,0,0,1,5.1.1,11,11,0,0,0,6.6.4c1.2-.4,2.6-1.5,5-2.7s4.7-3.6,6.3-4.1,5.9,3.1,8.7,3.4c10.2,1,14.5-10.5,15-11.3s2.8-.9,2.7.6a5.8,5.8,0,0,0,1.4,4.3c2,2.1,3.8.3,5.9-1.3a7.4,7.4,0,0,1,6.9-1.3c3.2,1.3,7.4-.6,7.4-.6a20.8,20.8,0,0,0,4.6-2.6c.8-.6,2.1-1.9,3.3-2.7,3.4-2.5,6.1-7.4,7.1-7.9a9.2,9.2,0,0,1,3.7,0c.8.1.2.8,2.9.9s2.7,1.5,2.3,2.3-8,3.5-8,3.5c-2.8,1.4-2.7,2.7-2.3,3.7,1.9,3,8.8,2.4,8.8,2.4,1.7-.2,9.3-4.9,9.9-6a6.7,6.7,0,0,1,3.3-1.8c2.7-.8,4.8-.8,9.7-.9s4.3.6,8.7,1C443.3,226,439.4,220,436.3,219.9Zm-154.8-9.6c1.2-2,2-1.5,3-1.8s.6,3.9.4,5.2-2.2,3.3-2.9,4.7-1.3,3.5-3.4,6.9-3.4,3.9-3.3.6S280.3,212.4,281.5,210.3ZM129,261.8s-1-.1-1-1.7a3.2,3.2,0,0,1,.7-2.4s.9.6.9,1.1a10.4,10.4,0,0,0,.2,1.5C129.9,261.1,129,261.8,129,261.8Zm42.7,18.7c-1.2,1.1-5.4,3.8-8.2,1s-1.8-9.3-.4-10.6,3.6-.6,4.8.2,4.7,3.4,6.1,3.4S172.8,279.4,171.7,280.5Zm42.9-36.1c-.4-1.6,1.4-5.7,2.2-8.5a101.4,101.4,0,0,1,3.8-10.4c.6-1.5.8-3.2,1.4-2.7s1,.5.3,4.6c-.4,2-.2,5.1-2.7,9.4a58.5,58.5,0,0,0-2.6,5.6C216.4,244,214.7,244.8,214.6,244.4Zm.9,11.9c2.3-3.1,7.3-1.9,7.4-.8s-2.8,3.9-5,4c-.6,0-2.3.1-2.9-.5S214.8,257.2,215.5,256.3Zm31.8-.5c-1.3,2.6-2.4,4.3-4.3,4.5-5.1.5-3.1-5.8-1.8-8.5s2.8-3.6,4-4.2,4.1-.8,5.1.2S248.3,254,247.3,255.8Zm104.8-22.4c-1.2,1-5.2.9-7,.3s-2.3-4.9-.9-10.5c1-4,4.4-2.2,5.8-1.7s4.3,2.9,4.7,5.4S353.3,232.3,352.1,233.4Zm51.1-27.6c-1.2,1.7-1.7,2.4-2.3,1.5s.8-4.4.8-4.4,1.2.3,2.8.8A14.8,14.8,0,0,0,403.2,205.8Zm16,.1a3.7,3.7,0,1,1,3.6-3.6A3.6,3.6,0,0,1,419.2,205.9Zm0-6.7a3,3,0,0,0-3,3.1,3,3,0,0,0,3,3.1,3.1,3.1,0,0,0,3.1-3.1A3.1,3.1,0,0,0,419.2,199.2Zm.9,5-.9-1.6h-.6v1.6H418v-3.9h1.4a1.1,1.1,0,0,1,1.2,1.1,1,1,0,0,1-.8,1.1l.9,1.7Zm-.8-3.5h-.7v1.4h.7c.5,0,.8-.2.8-.7A.7.7,0,0,0,419.3,200.7Z"
            transform="translate(-72 -194.1)"/>
        </svg>
      </a>
    </div>
    <div class="grid-x small-12 medium-8 middle-8 large-9 align-bottom navigation-header on-light verlag-bold">
      <ul class="cell">
        <li>
          <router-link
            :to="{name: 'portfolio'}"
            tag="a"
            active-class="active">PORTFOLIO</router-link>
        </li>
        <li>
          <router-link
            :to="{name: 'experience'}"
            tag="a"
            active-class="active">EXPERIENCE</router-link>
        </li>
        <li>
          <router-link
            :to="{name: 'contact'}"
            tag="a"
            active-class="active">CONTACT</router-link>
        </li>
      </ul>

      <!--
      <ul class="cell on-resume">
        <li>Dave Kaplan</li>
        <li><a href="mailto:work@workalicious.com">work@workalicious.com</a></li>
        <li><a href="tel:773-597-5001">773-597-5001</a></li>
      </ul>
      -->

    </div>
  </nav>
</template>

<script>
  export default {
    data() {
      return {
        bodyElem: document.body,
      }
    },
    methods: {
      navigateToHome() {
        this.$router.push('/');
      }
    },
    beforeCreated() {
      console.log("HeaderLight BEFORE CREATED");
    },

    created() {
      console.log("HeaderLight CREATED");
    },

    beforeMount() {
      console.log("HeaderLight BEFORE MOUNT");
    },

    mounted() {
      console.log("HeaderLight MOUNTED");
      this.bodyElem.classList.add("background-light");
    },

    beforeUpdate() {
      console.log("HeaderLight BEFORE UPDATE");
    },

    updated() {
      console.log("HeaderLight UPDATED");
    },

    destroyed() {
      console.log("HeaderLight DESTROYED");
      this.bodyElem.classList.remove("background-light");
    },
  }

</script>

<style lang="scss">
  @import '../css/colors';

  .background-light {
    background-color: $deepHaze;
  }

  ul.on-resume li {
    font-size: 0.875rem;
    a {
      color: $deepPewter;
      &:hover {
        color: $deepBlue;
      }
      &.active {
        color: $deepHaze;
        text-decoration: none;
      }
    }
  }

  :focus {
    /*outline: -webkit-focus-ring-color auto 1px;*/
    outline: gray auto 1px;
    outline-offset: 0.6rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/HeaderLight.vue